import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import { useMessage } from '../../contexts/MessageContext';
import Table  from '../common/Table';
import { useNavigate } from 'react-router-dom';
import Loading from '../common/Loading';

const apiUrl = window._env_?.REACT_APP_API_URL || "https://app.mylocaleventrentals.com/api";


const ExpenseList = ({ onSuccess }) => {
  const [form, setForm] = useState({
    date: '',
    category: '',
    amount: '',
    description: ''
  });
  const [loading, setLoading] = useState(true);
  const [expenses, setExpenses] = useState([]);
  const { logout, getToken } = useAuth();
  const { showSuccess, showError } = useMessage();
  const navigate = useNavigate();
  const columns = [
    { key: 'date', label: 'Date' },
    { key: 'category', label: 'Category', render: (value, row) => row.account ? row.account.name : '-' },
    { key: 'amount', label: 'Amount' },
    { key: 'paymentmethod', label: 'Method of Payment' },
    { key: 'description', label: 'Description' }
  ];
  const handleClick = (e) => {
    navigate(`/expense/${e.uuid}`);
  };

  useEffect(() => {
    // Fetch categories for dropdown if needed
    const fetchExpenses = async () => {
      const token = getToken ? getToken() : localStorage.getItem('token');
      if (!token) {
        logout();
        showError('Authentication required. Please log in.');
        return;
      }
      try {
        const res = await axios.get(`${apiUrl}/expense`, {
          headers: { 'x-auth-token': token }
        });
        if (res.data.success) {
          // Assuming expenses are returned as an array
          setExpenses(res.data.data || []);
          setLoading(false);
        } else {
          showError(res.data.message || 'Failed to fetch expenses');
          setLoading(false);
        }
      } catch (err) {
        showError('Failed to fetch expenses');
        setLoading(false);
      }
    };
    fetchExpenses();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = getToken ? getToken() : localStorage.getItem('token');
      if (!token) {
        logout();
        showError('Authentication required. Please log in.');
        setLoading(false);
        return;
      }
      const res = await axios.post(
        `${apiUrl}/expense`,
        form,
        { headers: { 'x-auth-token': token } }
      );
      if (res.data.success) {
        setForm({ date: '', category: '', amount: '', description: '' });
        showSuccess('Expense saved successfully!');
        if (onSuccess) onSuccess();
      } else {
        showError(res.data.message || 'Failed to save expense');
      }
    } catch (err) {
      showError('Failed to save expense');
    }
    setLoading(false);
  };
 if(loading){
    return <Loading />;
 }
  return (
    <div className="max-w-6xl mx-auto p-6 bg-gray-50 min-h-screen">
      <h2 className="text-2xl font-bold mb-4">Expenses</h2>
      <Table
        data={expenses}
        columns={columns}
        paginated={true}
        pageSize={10}
        showAddButton ={true}
        onAdd ={() => navigate('/expense/new')}
        onRowClick={(row) => handleClick(row)}
        rowKey="uuid"
      />
    </div>
  );
};

export default ExpenseList;
